import { Clock } from 'lucide-react';
import { LeadMaintenanceItem } from '@/components/LeadMaintenanceItem';
import type { MaintenanceItem } from '@/models/entities/lead';

interface LeadMaintenanceProps {
  readonly maintenanceItems: MaintenanceItem[];
}

export function LeadMaintenance({ maintenanceItems }: LeadMaintenanceProps) {
  const totalLaborHours = maintenanceItems.reduce(
    (total, item) => total + item.srts.reduce((sum, srt) => sum + srt.hours, 0),
    0,
  );

  return (
    <section aria-labelledby="maintenance-heading" className="mb-6">
      <h3
        id="maintenance-heading"
        className="inline-block bg-[#e8e8e8] px-2 py-1 text-xs font-semibold rounded mb-2 "
      >
        MAINTENANCE
      </h3>
      <div className="border-b border-gray-300 mb-4"></div>
      {maintenanceItems.map((item) => (
        <LeadMaintenanceItem key={item.description} item={item} />
      ))}
      <div className="grid grid-cols-3 gap-3">
        <dl className="bg-blue-50 text-blue-700 rounded p-3 flex items-center gap-2">
          <dt className="text-xs font-semibold flex items-center gap-2">
            <Clock className="w-4 h-4" aria-hidden="true" />
            Total Labor Hours
          </dt>
          <dd className="ml-auto text-xs font-bold">{totalLaborHours} hrs</dd>
        </dl>
      </div>
    </section>
  );
}
